// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M12 4L3.99999 11.9861\" stroke=\"#060606\" stroke-width=\"4\" stroke-linecap=\"round\"/> <path d=\"M12 12L4 4.01384\" stroke=\"#060606\" stroke-width=\"4\" stroke-linecap=\"round\"/> </svg> ";
// Exports
module.exports = code;